import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=16f93f3a"
import script from "./Layout.ts?vue&type=script&lang=ts&external"
export * from "./Layout.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports